/* eslint-disable react/display-name */
import React from 'react';
import { HelpPanel } from 'modules/core/hooks/useHelpPanel.hook';
import { Card } from '../Cards/Card';
import { ToolContent } from './ToolContent';

const HOME_USER_GUIDE_LINK = 'https://w.amazon.com/bin/view/MarketingSpendPlatform/UserGuides/ReceiptsDashboard/';

export const homePanels: HelpPanel<Card>[] = [
    {
        key: Card.CreateSpendDistribution,
        content: () => (
            <ToolContent
                header="helpPanel.createSpendDistribution.header"
                paragraphs={[
                    'helpPanel.createSpendDistribution.intro',
                    'helpPanel.createSpendDistribution.s1',
                    'helpPanel.createSpendDistribution.s2',
                    'helpPanel.createSpendDistribution.s3',
                    'helpPanel.createSpendDistribution.outro'
                ]}
                link={HOME_USER_GUIDE_LINK + '#HCreatespenddistribution'}
            />
        )
    },
    {
        key: Card.SoftClosePOs,
        content: () => (
            <ToolContent
                header="helpPanel.softClosePos.header"
                paragraphs={[
                    'helpPanel.softClosePos.intro',
                    'helpPanel.softClosePos.s1',
                    'helpPanel.softClosePos.s2',
                    'helpPanel.softClosePos.s3',
                    'helpPanel.softClosePos.outro'
                ]}
                link={HOME_USER_GUIDE_LINK + '#HSoftclosePOs'}
            />
        )
    },
    {
        key: Card.ConfirmReceipts,
        content: () => (
            <ToolContent
                header="helpPanel.confirmReceipts.header"
                paragraphs={[
                    { content: 'helpPanel.confirmReceipts.intro' },
                    { content: 'helpPanel.confirmReceipts.s1' },
                    { content: 'helpPanel.confirmReceipts.s2' },
                    {
                        header: 'helpPanel.confirmReceipts.individually',
                        content: 'helpPanel.confirmReceipts.individuallyDetail'
                    },
                    {
                        header: 'helpPanel.confirmReceipts.inBulk',
                        content: 'helpPanel.confirmReceipts.inBulkDetail'
                    }
                ]}
                link={HOME_USER_GUIDE_LINK + '#HConfirmreceipts'}
            />
        )
    },
    {
        key: Card.ReceivePOLines,
        content: () => (
            <ToolContent
                header="helpPanel.receivePoLines.header"
                paragraphs={[
                    { content: 'helpPanel.receivePoLines.intro' },
                    { content: 'helpPanel.receivePoLines.s1' },
                    { content: 'helpPanel.receivePoLines.s2' },
                    {
                        header: 'helpPanel.receivePoLines.individually',
                        content: 'helpPanel.receivePoLines.individuallyDetail'
                    },
                    {
                        header: 'helpPanel.receivePoLines.inBulk',
                        content: 'helpPanel.receivePoLines.inBulkDetail'
                    }
                ]}
                link={HOME_USER_GUIDE_LINK + '#HReceivePOlines'}
            />
        )
    },
    {
        key: Card.TopAccounts,
        content: () => (
            <ToolContent
                header="helpPanel.topAccounts.header"
                paragraphs={[
                    { content: 'helpPanel.topAccounts.intro' },
                    {
                        header: 'helpPanel.topAccounts.contributor',
                        content: 'helpPanel.topAccounts.contributorDetail'
                    },
                    {
                        header: 'helpPanel.topAccounts.defect',
                        content: 'helpPanel.topAccounts.defectDetail'
                    },
                    { content: 'helpPanel.topAccounts.use' },
                    { content: 'helpPanel.topAccounts.s1' },
                    { content: 'helpPanel.topAccounts.s2' },
                    { content: 'helpPanel.topAccounts.s3' }
                ]}
                link={HOME_USER_GUIDE_LINK + '#HTopdefectcontributors'}
            />
        )
    }
];
